<template>
  <li :class="flag">
    <button
      type="button"
      class="btn btn-tabmenu"
      :data-target="getTabIndex"
      @click="clickTabmenu"
    >
      <div class="text" v-html="item.menu_disp_nm"></div>
    </button>
  </li>
</template>

<script>
/*
 *  화면명   : 햄버그메뉴 좌측 탭 아이템 Component
 *  화면ID   : MenuTab
 *  작성자   : 이상민
 *  수정이력 :
 *      20210310 최초작성
 */
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    tabindex: {
      type: Number,
      required: true
    }
  },
  created() {
    if (this.tabindex === 0) {
      this.flag = "active";
    }
  },
  data() {
    return {
      flag: ""
    };
  },
  computed: {
    getTabIndex() {
      return "tabmenu" + (this.tabindex + 1);
    }
  },
  methods: {
    clickTabmenu(event) {
      const evtObj = $(event.target).parent("button");
      const wrap = evtObj.data("target");

      $(".sub-ui-side-list li").removeClass("active");
      evtObj.parent("li").addClass("active");

      $(".sub-ui-c").hide();
      $("#" + wrap).show();
    }
  }
};
</script>
